import { Navigate } from "react-router-dom";
import { getLocalStorageItem } from "../Helper/helper";

const PrivateRoute = ({ children }) => {
	const AUTH_TOKEN = getLocalStorageItem("ORDER_AUTH_TOKEN");

	if (AUTH_TOKEN) {
		return children;
	} else {
		return <Navigate to="/login" replace />;
	}
};
export default PrivateRoute;
